export const getLoginContainerStyles = (isLargeDevice: boolean) => `
    flex flex-col
    border rounded-[24px] ${isLargeDevice ? 'p-[32px]' : 'p-[16px]'}
`

export const loginTextStyles = `text-xl-semibold`

export const loginDescriptionStyles = `text-md-regular mb-32px`

export const captchaContainer = 'flex items-center justify-center mt-[24px]'
